export const isIOS = () => /iP(ad|hone|od)/i.test(navigator.userAgent);
export const isAndroid = () => /Android/i.test(navigator.userAgent);
export const isMobile = () => isIOS() || isAndroid();

export const isInAppWebView = () => {
  const ua = navigator.userAgent || '';
  const iosWv = isIOS() && !/Safari/i.test(ua);
  const andWv =
    isAndroid() && (/; wv\)/i.test(ua) || /Version\/\d+\.\d+/i.test(ua));
  const vendors =
    /(FBAN|FBAV|FB_IAB|Instagram|Line\/|Twitter|TikTok|Snapchat|Pinterest|WeChat|WhatsApp)/i.test(
      ua
    );
  return iosWv || andWv || vendors;
};

export const isPWADisplayMode = () => {
  const mm = window.matchMedia?.('(display-mode: standalone)');
  const standalone = !!(mm && mm.matches);
  const iosStandalone = (window as any).navigator?.standalone === true;
  return standalone || iosStandalone;
};
